import { API_URL_MEDIA } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const deleteMedia = (uuid: string) =>
  apiInstance({
    url: API_URL_MEDIA + uuid,
    method: "delete",
  });

export default deleteMedia;
